<div class="position-relative">

  <!-- Button Toggle Group -->
  <div class="inline-edit-button-group">
    <mat-button-toggle-group
      #group="matButtonToggleGroup"
      class="bp-button"
      [value]="selectedLanguage">

      <!-- Language Switch -->
      <mat-button-toggle
        value="en"
        (change)="changeLanguage('en')"
        aria-label="Select language english">
        EN
      </mat-button-toggle>
      <mat-button-toggle
        value="de"
        (change)="changeLanguage('de')"
        aria-label="Select language german">
        DE
      </mat-button-toggle>

      <!-- Copy Button -->
      <mat-button-toggle
        value="copy"
        (change)="copyAction(); resetLanguageSelection()"
        aria-label="Copy">
        <mat-icon>
          <span class="material-symbols-outlined">content_copy</span>
        </mat-icon>
      </mat-button-toggle>

      <!-- Insert Button -->
      <mat-button-toggle
        *ngIf="copiedContent?.length"
        value="insert"
        (change)="insertAction(); resetLanguageSelection()"
        aria-label="Insert">
        <mat-icon>
          <span class="material-symbols-outlined">file_save</span>
        </mat-icon>
      </mat-button-toggle>

      <!-- Delete Button -->
      <mat-button-toggle
        *ngIf="isEditMode"
        value="delete" (change)="confirmDelete()"
        aria-label="Delete">
        <mat-icon>
          <span class="material-symbols-outlined">delete</span>
        </mat-icon>
      </mat-button-toggle>

      <!-- Cancel Button -->
      <mat-button-toggle
        value="cancel"
        (change)="cancelAction()"
        aria-label="Cancel">
        <mat-icon><span class="material-symbols-outlined">close</span></mat-icon>
      </mat-button-toggle>

      <!-- Save Button -->
      <mat-button-toggle
        value="save"
        (change)="saveAction()"
        aria-label="Save">
        <mat-icon>
          <span class="material-symbols-outlined">check</span>
        </mat-icon>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>


  <div #editor class="block-editor">
  </div>

</div>
